import { Box, Typography } from '@mui/material';
import { useUserSetting } from '../../contexts/UserSettingsContext';
import { emsToDisplay } from '../../services/utils/DateFormat';

// Renders a single field in the ContentHeaderPanel based on a field definition.
// Props:
//   def  — one entry from CONTENT_HEADER_FIELD_DEFS
//   value — raw value from the entry object
const ContentHeaderField = ({ field, def, value }) => {
    const chipDateTimeFormat = useUserSetting('contentPanel.chipDateTimeFormat');

    const getDisplay = () => {
        if (def.getDisplayValue) return def.getDisplayValue(value);
        if (def.type === 'date') return emsToDisplay(value, chipDateTimeFormat);
        return value || '—';
    };

    const displayValue = getDisplay();

    const getValueColor = () => {
        if (displayValue === '—') {
            return 'var(--j-text)';
        }

        if (!def.getValueColor) {
            return 'var(--j-text)';
        }

        return def.getValueColor(value);
    };

    const valueColor = getValueColor();
    const labelColor = def.labelColor || 'var(--j-muted)';

    return (
        <Box
            id={`chf-${def.key}`}
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '4px',
                px: '6px',
                py: '2px',
                mr: '4px',
                border: '0.5px solid #294766',
                borderRadius: '3px',
                flexShrink: def.width ? 0 : undefined,
                '&:hover': { borderColor: '#66b2ff' },
            }}
        >
            <Typography
                sx={{
                    color: labelColor,
                    fontSize: '11px',
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: 1.2,
                    p: 0,
                    m: 0,
                }}
            >
                {def.label}:{' '}
            </Typography>

            {/* <JTooltip content={<span>{displayValue}</span>} disabled={displayValue === '—' || def.type === 'date'}> */}
            <Typography
                sx={{
                    color: `${valueColor} !important`,
                    fontSize: '11px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: 1,
                    p: 0,
                    m: 0,
                }}
            >
                {displayValue}
            </Typography>
            {/* </JTooltip> */}
        </Box>
    );
};

export default ContentHeaderField;
